export default __webpack_public_path__ + "static/media/feiwalk2.3473a06e.gif";